import React from 'react';
import { shimmer } from './shimmer';
import './skeleton.scss';

export const toBase64 = (str: string) =>
    typeof window === 'undefined'
        ? Buffer.from(str).toString('base64')
        : window.btoa(str);

interface SkeletonProps {
    children?: React.ReactNode;
    width: number;
    height: number;
    'data-testid'?: string;
}

export const Skeleton = ({
    children,
    width = 100,
    height = 20,
    'data-testid': dataTestId,
}: SkeletonProps) => {
    const shimmerBase64 = `data:image/svg+xml;base64,${toBase64(
        shimmer(width, height)
    )}`;

    return (
        <div
            className="pre-loader-skeleton"
            data-testid={dataTestId}
            role="progressbar"
            style={{
                width: `${width}px`,
                height: `${height}px`,
            }}
        >
            <div
                className="bg-transparent"
                style={{
                    backgroundImage: `url(${shimmerBase64})`,
                    backgroundSize: 'cover',
                }}
            />
            <div className="transition-opacity">{children}</div>
        </div>
    );
};
